import { useEffect, useRef } from "react";

import { useBlocker } from "@tanstack/react-router";

export const usePrompt = (uploading: boolean, message: string): void => {
  const initialConfirmedRef = useRef(false);

  useEffect(() => {
    if (!uploading) return;

    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", onBeforeUnload, { capture: true });
    return () => window.removeEventListener("beforeunload", onBeforeUnload, { capture: true });
  }, [uploading]);

  useBlocker({
    shouldBlockFn: () => {
      if (!uploading) return false;
      if (initialConfirmedRef.current) {
        initialConfirmedRef.current = false;
        return false;
      }
      return !window.confirm(message);
    },
    enableBeforeUnload: uploading,
  });
};
